<template>
  <!-- style="background: #fff;" -->
  <div class="page-content">
    <div class="container-fluid" style="min-height: 80vh;">
      <div class="page-content__header-description">
        Welcome to Arnergy
        Solarbase&trade;
      </div>
      <div>
        <div class="row">
          <can I="create" a="device">
            <div class="col-xl-4 col-lg-4 col-md-6">
              <div class="widget widget-alpha widget-alpha--color-amaranth" style="height: 90%">
                <div class="top-widget-box">
                  <div class="top-widget-box__header">
                    <span class="title">Expiry</span>
                    <i class="fa fa-calendar fa-2x icon"></i>
                  </div>
                  <div class="top-widget-box__body">
                    <h1>Feb 19th</h1>
                    <p>2019</p>
                  </div>
                </div>
              </div>
            </div>
          </can>
          <can I="create" a="wallet">
            <div class="col-xl-4 col-lg-4 col-md-6">
              <div class="widget widget-alpha widget-alpha--color-amaranth" style="height: 90%">
                <div class="top-widget-box">
                  <div class="top-widget-box__header">
                    <span class="title">Wallet Balance</span>
                    <i class="fa fa-credit-card fa-2x icon"></i>
                  </div>
                  <div class="top-widget-box__body">
                    <h1>₦{{getUserSession.wallet}}</h1>
                    <p>
                      <b-button :variant="`warning`" size="sm" to="/shs/pay?type=wallet">Fund Wallet</b-button>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </can>

          <!-- <can I="read" a="notification">
            <div class="col-xl-4 col-lg-4 col-md-6">
              <div class="widget widget-alpha widget-alpha--color-amaranth" style="height: 90%">
                <div>
                  <div class="widget-alpha__amount">Notifications</div>
                  <div class="widget-alpha__description">None</div>
                </div>
              </div>
            </div>
          </can>-->

          <can I="create" a="device">
            <div class="col-xl-4 col-lg-4 col-md-12">
              <div class="widget widget-alpha widget-alpha--color-amaranth" style="height: 90%">
                <div class="top-widget-box">
                  <div class="top-widget-box__header">
                    <span class="title">Devices Capacity</span>
                    <i class="fa fa-hdd-o fa-2x icon"></i>
                  </div>
                  <div class="top-widget-box__body">
                    <h1>
                      12
                      <span class="title">kWAh</span>
                    </h1>
                  </div>
                </div>
              </div>
              <!-- <div class="widget widget-alpha widget-alpha--color-amaranth" style="height: 90%">
                <div>
                  <div class="widget-alpha__amount">Devices Capacity</div>
                  <div class="widget-alpha__description">12kWAh</div>
                </div>
              </div>-->
            </div>
          </can>
        </div>
        <!-- <hr style="margin-top:20px; margin-bottom: 20px;"> -->
        <div class="row" style="margin-top:20px;">
          <div class="col-xl-5 col-lg-5 col-md-12 sh">
            <el-card class="box-card widget">
              <div slot="header" class="widget_header">
                <span class="widget_header__title">Device Stat</span>

                <el-input
                  style="max-width: 200px"
                  placeholder="Type something"
                  prefix-icon="el-icon-search"
                  v-model="searchTerm"
                ></el-input>
              </div>

              <!-- :search-options="searchOption" -->
              <!-- <vue-good-table
                :columns="columns"
                :rows="rows"
                :select-options="selectOption"
                :search-options="{enabled: true,
                externalQuery: searchTerm}"
                :pagination-options="{enabled: true}"
              >
                <template slot="pagination-bottom" slot-scope="props">
                  <grey-pagination
                    :total="props.total"
                    :pageChanged="props.pageChanged"
                    :perPageChanged="props.perPageChanged"
                  ></grey-pagination>
                </template>
              </vue-good-table> -->
            </el-card>
          </div>
          <div class="col-xl-4 col-lg-4 col-md-12 sh">
            <el-card class="box-card widget">
              <div slot="header" class="widget_header" style="justify-content: space-between;">
                <span class="widget_header__title">Performance</span>
                <el-select v-model="value" placeholder="Filter" style="max-width: 200px">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
              <Center style="height: 200px;">
                <i class="fa fa-hourglass fa-4x"></i>
                Under Construction
              </Center>
            </el-card>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-12 sh">
            <el-card class="box-card widget">
              <div slot="header" class="widget_header">
                <span class="widget_header__title">Device Stat</span>
              </div>
              <!-- <div v-for="o in 8" :key="o" class="text item">{{'List item ' + o }}</div> -->
              <Center style="height: 200px;">
                <i class="fa fa-hourglass fa-4x"></i>
                Under Construction
              </Center>
            </el-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import Vue from "vue";
import {
  Card,
  Select,
  Option,
  OptionGroup,
  Input,
  InputNumber
} from "element-ui";
import { HTTP as IOTHTTP } from "../../../store/actions";
Vue.use(Card);
Vue.use(Select);
Vue.use(Option);
Vue.use(OptionGroup);
Vue.use(Input);
Vue.use(InputNumber);

export default {
  data() {
    return {
      searchTerm: "",
      value: null,
      searchOption: {},
      options: [
        {
          value: "Option1",
          label: "Option1"
        },
        {
          value: "Option2",
          label: "Option2"
        },
        {
          value: "Option3",
          label: "Option3"
        },
        {
          value: "Option4",
          label: "Option4"
        },
        {
          value: "Option5",
          label: "Option5"
        }
      ],
      selectOption: {
        enabled: true
      },
      columns: [
        {
          label: "Full Name",
          field: "fullname"
        },
        {
          label: "Email",
          field: "email"
        },
        {
          label: "Phone Number",
          field: "phonenumber",
          type: "number"
        },
        {
          label: "Customer Type",
          field: "customertype"
        },
        {
          label: "Last Seen",
          field: "lastseen"
        }
      ],
      rows: [
        {
          id: 1,
          fullname: "John Wick",
          email: "johnwick@gmail.com",
          phonenumber: "2011-10-31",
          customertype: "Agent",
          lastseen: "Dec 9, 2017 "
        },
        {
          id: 2,
          fullname: "Jane Aniston",
          email: "janeaniston@gmail.com",
          phonenumber: "2011-10-31",
          customertype: "CEO",
          lastseen: "14 minutes ago"
        },
        {
          id: 3,
          fullname: "Susan Hall",
          email: "susanhall@gmail.com",
          phonenumber: "2011-10-30",
          customertype: "Manager",
          lastseen: "6 Hours ago"
        },
        {
          id: 4,
          fullname: "Chris Pratt",
          email: "chrispratt@gmail.com",
          phonenumber: "2011-10-11",
          customertype: "Manager",
          lastseen: "20 Minutes ago"
        },
        {
          id: 5,
          fullname: "Dan Schwarz",
          email: "danschwarz@gmail.com",
          phonenumber: "2011-10-21",
          customertype: "Engineer",
          lastseen: "5 Minutes ago"
        },
        {
          id: 6,
          fullname: "Jax Briggs",
          email: "jaxbriggs@gmail.com",
          phonenumber: "2011-10-31",
          customertype: "Security",
          lastseen: "2 Minutes ago"
        }
      ]
    };
  },
  computed: {
    ...mapGetters([
      "getUserById",
      "getDeviceById",
      "getUsers",
      "getDummy",
      "getDevices",
      "getUserSession"
    ]),
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({
          text: f.label,
          value: f.key
        }));
    }
  },
  components: {
    // GreyPagination
  },
  methods: {
    navTo(page) {
      this.$router.push({
        name: page,
        params: {}
      });
      // console.log(user);
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getStatData(date = "06-12-2019") {
      console.log('>>>>>>>>>>>>>>>>>>>>>>>');
      let container = this;
      var headers = {
        "Content-Type": "application/plain"
      };
      let data = {
        TableName: "EnergyData",
        KeyConditionExpression: "Date = :key",
        ExpressionAttributeValues: {
          ":key":  date
        },
        // Limit: limit,
        // ScanIndexForward: false
      };
      // console.log(data)
      IOTHTTP.post(`/devicedata`, data, {
        headers
      })
        .then(resp => {
          let DevData = resp.data.Items;
          console.log('>>>>>>>>>>>>>>>>>>>>>>>')
          console.log(DevData);
        })
        .catch(err => console.log(err));
    }
  },
  mounted() {
    // this.getStatData();
    if (!this.$can("read", "dashboard")) {
      this.$router.push({
        path: "/"
      });
      return;
    }
    //console.log(JSON.stringify(this.getUserSession));
    // this.$ability.update([{ subject: 'CUSTOMER', actions: 'all' }]);
    // console.log(this.$ability);
  }
};
</script>

<style lang="scss" scoped>
.widget_header {
  display: flex;
  flex-flow: row;
  justify-content: space-between;
}
.widget-notifications {
  height: 385px !important;
}

.card-title {
  font-size: 3.6rem;
}

span.fa {
  color: #e7643e;
  border: 1px solid rgb(196, 196, 196);
  border-radius: 50%;
  margin-bottom: 8px;
  line-height: 80px;
  width: 80px;
  height: 80px;
}

.widget-subtitle {
  color: #707070;
  font-size: 1.4rem;
}

table,
th,
td {
  border: none;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/dashboard/index.vue